<div class="ngx-backdrop-container">

  <div [class]='"ngx-backdrop-custom-backdrop " + backdropClass' *ngIf='isVisible'>

    <div [class]='spinner' *ngIf='spinner'></div>

    <span *ngIf='text' [class]='"ngx-backdrop-loading-text " + textClass'>{{ text }} </span>

    <ng-content select=".backdrop-content"></ng-content>

  </div>

  <ng-content>

  </ng-content>
  
</div>